module.exports = __webpack_public_path__ + "blissweb-bd.7d0cce6f9821e4752118.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BlissWeb-Bd/blissweb-bd.svg
// module id = 388
// module chunks = 5